declare var window: any;

const HandleFilterDropdown = {
  mounted(this: any) {
    const toggleFilterDropdown = ({ open }: any) => {
      var event = new CustomEvent("toggle-filter-dropdown", { detail: open });
      window.dispatchEvent(event);
    };
    this.handleEvent("toggle_filter_dropdown", toggleFilterDropdown);
  },
};

export default HandleFilterDropdown;
